export default __webpack_public_path__ + "static/media/doctor.fee9b704.png";